import { MerchantService } from 'src/app/services/merchant/merchant.service';
import { DomiciliacionCtService } from 'src/app/services/domiciliacion-ct/domiciliacion-ct.service';
import { DatePipe } from '@angular/common';
import { noUndefined } from '@angular/compiler/src/util';
import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import html2canvas from 'html2canvas';

import { async } from '@angular/core/testing';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { mobiscroll, MbscDatetimeOptions } from '@mobiscroll/angular';
import { AuthService } from 'src/app/services/auth/auth.service';
import { RedirecFormService } from 'src/app/services/redirec-form.service';
import { UserService } from 'src/app/services/user/user.service';
import { FeeService } from 'src/app/services/fee.service';
import { CatalogProductService } from 'src/app/services/catalog-product.service';
import { DirectDebitService } from 'src/app/services/direct-debit/direct-debit.service';
import { lastValueFrom } from 'rxjs';

import { environment } from 'src/environments/environment';
import { isNullOrUndefined } from 'util';
import { ApproveConditionsComponent } from '../approve-conditions/approve-conditions.component';
import * as alertifyjs from 'alertifyjs';
import { log } from 'console';

mobiscroll.settings = {
  lang: 'es',
  theme: 'ios',
  themeVariant: 'light'
};

import Swal from'sweetalert2';
import { armarCuerpoEliminar, mensajeErrorEliminar, validarMotivo } from './eliminar-cliente.logica';

// Nueva interfaz para las opciones del perfil
interface ProfileOption {
  id: string;
  title: string;
  description: string;
  icon: string;
  color: string;
  route?: string;
  action?: string;
  requiredRoles?: string[];
  rbacPermissions?: string[];
  condition?: string;
  variant?: 'default' | 'danger';
}

@Component({
  selector: 'app-contact-profile',
  templateUrl: './contact-profile.component.html',
  styleUrls: [],
  providers: [DatePipe],
})
export class ContactProfileComponent implements OnInit {
  @ViewChild('pocision') pocision!: TemplateRef<any>;
  @ViewChild('paymentMethodsDrawer') paymentMethodsDrawer!: TemplateRef<any>;

  /** Abre el drawer lateral con el listado de cuentas bancarias del cliente en modo solo-lectura.
   *  Para registrar/editar el admin debe ir al Onboarding — esta vista es solo consulta rápida. */
  openPaymentMethodsReadOnly = (): void => {
    if (!this.paymentMethodsDrawer) return;
    this.offcanvasService.open(this.paymentMethodsDrawer, {
      position: 'end',
      panelClass: 'offcanvas-end-wide'
    });
  };

  usQuote: any = false;
  code_person: any;
  edit_quote: any;
  new_quote: any;
  submit_disabled_quote: any;

  supUse: any;
  queryParams: any;
  person: any;
  section_transactions: any = [];
  transaction: any = {};
  section_transaction: any;
  loading = false;
  buro_response: any;
  buro: any;
  buro_score: any;
  activatePsico: any;
  showActivatePsico: any;

  loading_ap = true;
  loading_buro = false;
  psicometrico: any;
  psicometrico_response: any;
  psicometrico_array: any = [];
  status_approved: any;
  type_approved: any;
  clientQuota: any;
  clientAprov: any;
  clientAprovBuro: any;
  searchPerson: any;
  countInvoice: any;

  identityResponse: any;
  result: any;
  errorMsg: any;
  loadQuota = false;
  // loadPlans = false;
  env = environment;
  base_amount: any;
  usQuoteClien = false;
  direct_debit_customer: any = [];
  analysis_response: any;

  fee_to_apply: any;

  fee_later_payment_code = 'C001';
  params_payment:any;

  // Banner: penalidad de persona pendiente para reactivación
  hasPendingPersonFees: boolean = false;

  // Estado de validación de fee C004
  reactivationStatus: any = null;
  loadingReactivationStatus = false;
  pendingPersonDueTotal: number = 0;

  // Recalculo manual de mora (botón en perfil para casos sospechosos)
  isRefreshingMora: boolean = false;

  userComment:string = '';

  reasons = ["","Morosidad (Permite activarse al cancelar la deuda si aplica)", "Fallecimiento", "Fraude", "Falsificación de documentos", "Perdida incobrable", "Solicitado por el cliente", "Ex-empleado", "Incumplimiento de pago"]

  // 🆕 MULTI-PRODUCTO: Productos activos del sistema
  activeProducts: any[] = [];

  // ============================================
  // HISTORIAL DE CAMBIOS DE CUPO
  // ============================================
  quotaHistory: any[] = [];
  loadingHistory = false;
  historyPage = 1;
  historyLimit = 10;
  historyTotal = 0;
  historyTotalPages = 0;
  historyFilters = {
    nombreEjecutivo: ''
  };

  // Ir a pagar penalidad pendiente (monto precargado en UI)
  goToPayPendingPersonFees() {
    try {
      const code = this.person?.person?.code;
      if (!code) return;
      this.router.navigate(['/console/post/person', code]);
    } catch (e) {
      console.log(e);
    }
  }
  // Filtros de fecha (Mobiscroll)
  dateRangeStart: Date | null = null;
  dateRangeEnd: Date | null = null;
  // Configuración de Mobiscroll Date Picker (Desktop)
  desktopDateSettings: MbscDatetimeOptions = {
    display: 'bubble',
    touchUi: false,
    lang: 'es',
    theme: 'ios',
    themeVariant: 'light'
  };
  // Configuración de Mobiscroll Date Picker (Mobile)
  mobileDateSettings: MbscDatetimeOptions = {
    display: 'bottom',
    lang: 'es',
    theme: 'ios',
    themeVariant: 'light'
  };
  showHistorySection = false;

  // ============================================
  // TASA Bs/$ PARA MODAL DETALLE DE CRÉDITO
  // ============================================
  creditRate: number | null = null;
  creditRateAvailable = false;
  loadingCreditRate = false;
  downloadingCreditCapture = false;

  // ============================================
  // PRODUCTOS COMPRADOS POR EL CLIENTE
  // ============================================
  customerProducts: any[] = [];
  customerProductsSummary: any = null;
  customerProductsCurrency: any[] = [];
  loadingCustomerProducts = false;
  showCustomerProducts = false;

  // ============================================
  // DOMICILIACIONES BANCARIAS (sección colapsable)
  // ============================================
  showDirectDebitSection = false;

  // Array de opciones del perfil
  profileOptions: ProfileOption[] = [
    {
      id: 'sap',
      title: 'Gestión en SAP',
      description: 'Analizar, crear o modificar el cliente en SAP',
      icon: 'fas fa-cloud',
      color: 'bg-indigo-100 text-indigo-600',
      route: '/console/person/sap',
      requiredRoles: ['OWNER', 'ANALIST', 'EJECUTIVE'],
      rbacPermissions: ['contactos.gestion_sap.read']
    },
    {
      id: 'odoo',
      title: 'Gestión en Odoo',
      description: 'Revisar, anotar o actualizar el cliente en Odoo',
      icon: 'fas fa-link',
      color: 'bg-purple-100 text-purple-600',
      route: '/console/person/odoo',
      requiredRoles: ['OWNER'],
      rbacPermissions: ['contactos.gestion_odoo.read']
    },
    {
      id: 'onboarding',
      title: 'Onboarding',
      description: 'Completa el proceso de registro y verificación del cliente',
      icon: 'fas fa-user-check',
      color: 'bg-blue-100 text-blue-600',
      route: '/console/person/onboarding',
      requiredRoles: ['OWNER', 'ANALIST', 'EJECUTIVE'],
      rbacPermissions: ['contactos.onboarding.read', 'contactos.onboarding.update']
    },
    {
      id: 'quota',
      title: 'Consultar cupo',
      description: 'Verifica el cupo disponible y límites de crédito',
      icon: 'fas fa-search-dollar',
      color: 'bg-blue-100 text-blue-600',
      action: 'consultQuota',
      requiredRoles: [],
      rbacPermissions: ['contactos.cupo.read', 'cupo.consultar_cupo.read']
    },
    {
      id: 'plans',
      title: 'Consultar planes',
      description: 'Revisa los planes de crédito disponibles para el cliente',
      icon: 'fas fa-list-alt',
      color: 'bg-blue-100 text-blue-600',
      route: '/console/person/plans',
      requiredRoles: ['OWNER', 'ANALIST', 'EJECUTIVE'],
      rbacPermissions: ['planes.consultar_planes.read']
    },
    {
      id: 'financial-payments',
      title: 'Compras financiadas',
      description: 'Historial de compras y financiamientos activos',
      icon: 'fas fa-shopping-cart',
      color: 'bg-blue-100 text-blue-600',
      route: '/console/person/financial-payments',
      requiredRoles: ['OWNER', 'ANALIST', 'EJECUTIVE', 'ADMIN', 'FINANCIAL'],
      rbacPermissions: ['compras_financiadas.compras.read']
    },
    {
      id: 'client-installments-view',
      title: 'Gestión de Cobro',
      description: 'Ver la selección de cuotas como la ve el cliente en su app móvil',
      icon: 'fas fa-mobile-alt',
      color: 'bg-blue-100 text-blue-600',
      route: '/console/person/client-installments-view',
      requiredRoles: ['OWNER', 'ANALIST', 'EJECUTIVE'],
      rbacPermissions: ['gestion_cobro.consultar.read']
    },
    {
      id: 'payments',
      title: 'Pagos registrados',
      description: 'Consulta el historial de pagos realizados',
      icon: 'fas fa-money-bill-wave',
      color: 'bg-blue-100 text-blue-600',
      route: '/console/payments/person',
      requiredRoles: ['OWNER', 'ANALIST', 'EJECUTIVE', 'ADMIN', 'FINANCIAL'],
      rbacPermissions: ['pagos.pagos_registrados.read']
    },
    {
      id: 'fees',
      title: 'Penalidades',
      description: 'Gestiona penalidades y cargos adicionales',
      icon: 'fas fa-exclamation-triangle',
      color: 'bg-blue-100 text-blue-600',
      route: '/console/payments/person-fees',
      requiredRoles: ['OWNER', 'ANALIST', 'EJECUTIVE'],
      rbacPermissions: ['pagos.penalidades.read']
    },
    {
      id: 'new-payment',
      title: 'Nuevo Pagos',
      description: 'Registra un nuevo pago para el cliente',
      icon: 'fas fa-plus-circle',
      color: 'bg-blue-100 text-blue-600',
      route: '/console/post/person',
      requiredRoles: ['OWNER', 'ANALIST', 'EJECUTIVE'],
      rbacPermissions: ['pagos.nuevo_pago.create']
    },
    {
      id: 'cancel-penalty',
      title: 'Cancelar penalidad',
      description: 'Cancela penalidades aplicadas al cliente',
      icon: 'fas fa-ban',
      color: 'bg-red-100 text-red-600',
      route: '/console/post/person',
      condition: 'cancelPenalty',
      variant: 'danger',
      requiredRoles: ['OWNER', 'ANALIST'],
      rbacPermissions: ['pagos.cancelar_penalidad.cancel']
    },
    {
      id: 'otros-flujos-pago',
      title: 'Otros flujos de pago',
      description: 'Registrar sin conciliar o registrar y anular (devolución de fondos)',
      icon: 'fas fa-random',
      color: 'bg-blue-100 text-blue-600',
      route: '/console/otros-flujos-pago/person',
      requiredRoles: ['OWNER'],
      rbacPermissions: ['pagos.otros_flujos.read']
    },
    {
      id: 'nota-credito',
      title: 'Nota de crédito',
      description: 'Aplica una devolución de productos a un crédito específico',
      icon: 'fas fa-file-invoice-dollar',
      color: 'bg-blue-100 text-blue-600',
      route: '/console/nota-credito/person',
      requiredRoles: ['OWNER'],
      rbacPermissions: ['pagos.nota_credito.read']
    },
    {
      id: 'delete-client',
      title: 'Eliminar cliente',
      description: 'Elimina permanentemente el cliente del sistema',
      icon: 'fas fa-user-times',
      color: 'bg-red-100 text-red-600',
      action: 'deleteClient',
      variant: 'danger',
      requiredRoles: ['OWNER'],
      rbacPermissions: ['contactos.perfil.delete']
    }
  ];

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private _user: UserService,
    private sanitizer: DomSanitizer,
    private redirecFormService: RedirecFormService,
    private datePipe: DatePipe,
    private offcanvasService: NgbOffcanvas,
    public _auth: AuthService,
    public feeService: FeeService,
    private catalogService: CatalogProductService,
    private directDebitService: DirectDebitService,
    private _merchantSrv: MerchantService,
    private domiciliacionCt: DomiciliacionCtService
  ) {}

  ngOnInit(): void {
    this.getBase_amount();
    this.loadActiveProducts(); // 🆕 Cargar productos activos

    this._auth.auth$.subscribe((rep: any) => {
      let sessionUser = rep ? this._auth.sessionUser : null;

      if (
        sessionUser?.username == 'juan@hazling.com' ||
        sessionUser?.username == 'diribarren' ||
        sessionUser?.username == 'asarkis@totalmundo.com' ||
        sessionUser?.username == 'jesuli.montenegro@hazling.com' ||
        sessionUser?.username == 'nathalyaespisona@totalmundo.com' ||
        sessionUser?.username == 'agregorio@totalmundo.com'
      ) {
        this.supUse = true;
      }
    });

    this.activatedRoute.params.subscribe((params) => {
      this.queryParams = params;
      if (this.queryParams?.code) {
        this.getPerson();
      }
    });


  }

  // Métodos para manejar las opciones del perfil
  hasPermission(option: ProfileOption): boolean {
    if (this._auth.hasRbac$.getValue()) {
      if (option.rbacPermissions && option.rbacPermissions.length > 0) {
        return this._auth.hasAnyPermission(option.rbacPermissions);
      }
      return this._auth.hasModuleAccess('contactos');
    }
    if (!option.requiredRoles || option.requiredRoles.length === 0) return true;
    return option.requiredRoles.some(role => this._auth.IsPermitid([role]));
  }

  shouldShowOption(option: ProfileOption): boolean {
    if (!this.hasPermission(option)) return false;

    // Para la opción de penalidades regulares, siempre mostrar
    // La lógica de si hay penalidades o no se maneja dentro del componente
    if (option.id === 'fees') {
      return true; // Siempre mostrar la opción de penalidades
    }

    return true;
  }

  handleOptionClick(option: ProfileOption): void {
    if (!this.person?.person?.code) return;

    if (option.action === 'consultQuota') {
      if (!this.loadQuota) {
        this.pocisionBottom(this.pocision);
      }
      return;
    }

    if (option.action === 'deleteClient') {
      this.restClientBuro();
      return;
    }

    if (option.route) {
      this.router.navigate([option.route, this.person.person.code]);
    }
  }

  // Método para generar el fee de reactivación C004
  async generateReactivationFeeAction() {
    try {
      // Mostrar confirmación
      const result = await Swal.fire({
        title: 'Generar Penalidad de Reactivación',
        html: `
          <div class="text-left">
            <p class="mb-2"><strong>Cliente:</strong> ${this.person.person.code} - ${this.person.person.name} ${this.person.person.lastName}</p>
            <p class="mb-2"><strong>Días de mora:</strong> ${this.reactivationStatus.diasMorosidad} días</p>
            <p class="mb-2"><strong>Monto del fee:</strong> $${this.reactivationStatus.c004Amount} ${this.reactivationStatus.c004Currency}</p>
            <p class="mt-3 text-gray-600">¿Confirma la generación de la penalidad?</p>
          </div>
        `,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, generar',
        cancelButtonText: 'Cancelar'
      });

      if (!result.isConfirmed) return;

      // Llamar al endpoint para generar el fee
      const response = await lastValueFrom(
        this._user.generateReactivationFee(this.person.person.code)
      );

      if (response.success) {
        await Swal.fire({
          title: '¡Éxito!',
          html: `
            <div class="text-left">
              <p class="mb-2">Penalidad de reactivación generada exitosamente</p>
              <p class="mb-2"><strong>Monto:</strong> $${response.data.amount} ${response.data.currency}</p>
              <p class="text-gray-600">Puede ver la penalidad en la sección de Penalidades</p>
            </div>
          `,
          icon: 'success',
          confirmButtonText: 'Ver Penalidades'
        });

        // Redirigir a penalidades
        this.router.navigate(['/console/payments/person-fees'], {
          queryParams: { code: this.person.person.code }
        });
      }
    } catch (error: any) {
      console.error('Error generando fee C004:', error);
      
      let errorMessage = 'Error al generar la penalidad';
      if (error.error?.message) {
        errorMessage = error.error.message;
      } else if (error.error?.error === 'BLOCKED') {
        errorMessage = 'Cliente bloqueado permanentemente';
      } else if (error.error?.error === 'DUPLICATE') {
        errorMessage = 'Ya existe una penalidad C004 pendiente';
      } else if (error.error?.error === 'NO_FEE_APPLIES') {
        errorMessage = `Cliente no cumple condiciones (mora: ${error.error?.diasMorosidad || 0} días)`;
      }

      await Swal.fire({
        title: 'Error',
        text: errorMessage,
        icon: 'error',
        confirmButtonText: 'Entendido'
      });
    }
  }

  // Fuerza el recálculo de los indicadores de mora del cliente (Person.mora.*).
  // Útil cuando se sospecha que los contadores de fees/mora quedaron desactualizados
  // por algún flujo que no invalidó el caché. force=true ignora el chequeo de stale.
  async refreshMoraManual() {
    if (this.isRefreshingMora) return;
    if (!this.person?.person?.code) {
      await Swal.fire({ title: 'Sin cliente', text: 'No hay cliente cargado.', icon: 'warning' });
      return;
    }

    const confirm = await Swal.fire({
      title: 'Recalcular mora',
      html: `
        <div class="text-left">
          <p class="mb-2">Se recalcularán los indicadores de mora y fees pendientes para:</p>
          <p class="mb-2"><strong>${this.person.person.code}</strong> · ${this.person.person.name} ${this.person.person.lastName}</p>
          <p class="text-gray-600 text-sm">Esto puede tomar unos segundos. Úsalo si sospechas que los contadores quedaron desactualizados.</p>
        </div>
      `,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#aaa',
      confirmButtonText: 'Sí, recalcular',
      cancelButtonText: 'Cancelar'
    });
    if (!confirm.isConfirmed) return;

    this.isRefreshingMora = true;
    try {
      const resp: any = await this._user.refreshCustomerMora(this.person.person.code, true);
      await this.getPerson();
      alertifyjs.success(
        resp?.recalculated
          ? `Mora recalculada (${resp?.durationMs || 0}ms)`
          : 'Mora ya estaba al día'
      );
    } catch (err: any) {
      console.error('refreshMoraManual error:', err);
      await Swal.fire({
        title: 'No se pudo recalcular',
        text: err?.error?.error || err?.message || 'Error inesperado',
        icon: 'error',
        confirmButtonText: 'Entendido'
      });
    } finally {
      this.isRefreshingMora = false;
    }
  }

  // Método para aplicar el fee de reactivación (legacy)
  async applyReactivationFee() {
    try {
      // Guardar: si ya existe un fee de persona pendiente no permitir generar otro
      if (this.hasPendingPersonFees) {
        await Swal.fire({
          title: 'No disponible',
          text: `Este cliente ya tiene una penalidad de reactivación pendiente por ${this.pendingPersonDueTotal.toFixed(2)} USD`,
          icon: 'info',
          confirmButtonColor: '#10b981'
        });
        return;
      }

      // Confirmar con el usuario
      const result = await Swal.fire({
        title: '¿Generar Fee de Reactivación?',
        html: `
          <div class="text-left">
            <p class="mb-2">Se aplicará el fee de reactivación al cliente:</p>
            <p class="font-semibold">${this.person?.person?.name} ${this.person?.person?.lastName}</p>
            <p class="text-sm text-gray-600 mt-2">El cliente deberá pagar este fee antes de poder reactivar su cupo.</p>
          </div>
        `,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#10b981',
        cancelButtonColor: '#6b7280',
        confirmButtonText: 'Sí, generar fee',
        cancelButtonText: 'Cancelar'
      });

      if (!result.isConfirmed) return;

      // Mostrar loading
      Swal.fire({
        title: 'Generando fee...',
        html: 'Por favor espera',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      // Llamar al endpoint para aplicar el fee
      const response = await this._user.applyReactivationFee(this.person.person._id).toPromise();

      if (response.success) {
        await Swal.fire({
          title: '¡Fee Generado!',
          html: `
            <div class="text-left">
              <p class="mb-2">El fee de reactivación ha sido aplicado exitosamente.</p>
              <div class="bg-gray-100 p-3 rounded mt-3">
                <p class="text-sm"><strong>Monto:</strong> $${response.data.amount.toFixed(2)}</p>
                <p class="text-sm"><strong>Estado:</strong> ${response.data.paymentStatus}</p>
                <p class="text-sm"><strong>ID:</strong> ${response.data.feePersonId}</p>
              </div>
            </div>
          `,
          icon: 'success',
          confirmButtonColor: '#10b981'
        });

        // Recargar los datos del cliente
        this.getPerson();
      } else {
        throw new Error(response.error || 'Error al generar el fee');
      }

    } catch (error) {
      console.error('Error aplicando fee de reactivación:', error);
      const errorMessage = (error as {error?: {error?: string}, message?: string})?.error?.error || 
                          (error as {message?: string})?.message || 
                          'No se pudo generar el fee de reactivación';
      Swal.fire({
        title: 'Error',
        text: errorMessage,
        icon: 'error',
        confirmButtonColor: '#ef4444'
      });
    }
  }

  getBase_amount = async () => {
    try {
      let response = await this._user.getBase_amount();
      this.base_amount = response?.amount;
    } catch (error) {
      console.log(error);
    }
  };

  getSection_transaction_by_person = async (buro: any = false) => {
    try {
      this.loading_buro = true;
      const resp = await this._user.getSection_transaction_by_person({
        code: this.queryParams.code,
        type: 'ONBOARDING',
      });

      let result = resp?.resp;

      if (result?.section_transactions?.length > 4) {
        this.clientAprov = true;
      }

      result?.section_transactions.map((obj: any) => {
        let section_transaction = obj?.section_transaction;

        if (
          section_transaction?.code == 'BURO' &&
          obj.condition == 'COMPLETE'
        ) {
          this.getDataBuroSimple(this.person, false);
        }
        return obj;
      });
    } catch (error) {}
    this.loading_buro = false;

    this.loading = false;
  };

  getDataBuroSimple = async (item: any, reload = true) => {
    this.loading_buro = true;
    if (item?.identitys?.length > 0) {
      let params = {
        type_identity: item?.identitys[0]?.type_identity?.additionalType,
        identity: item?.identitys[0]?.identity,
        lastName: item?.person?.lastName,
        code_person: item?.person?.code,
      };

      try {
        const buro = await this._user.getDataBuro(params);

        this.buro = buro?.resp;

        if (this.buro.status_approved == 'APPROVED') {
          this.clientAprovBuro = true;
        }
      } catch (error) {
        console.log(error);
      }

      this.loading_buro = false;
    }
  };

  restClientBuro = async () => {
    const result = await Swal.fire({
      title: 'Eliminar cliente',
      html: `<p class="text-left" style="font-size:.95rem">Se borrarán los datos de este cliente. <strong>Esta acción no se puede deshacer.</strong> Cuéntanos por qué lo eliminas.</p>`,
      icon: 'warning',
      input: 'textarea',
      inputLabel: 'Motivo',
      inputPlaceholder: 'Escribe el motivo (mínimo 5 caracteres)',
      inputAttributes: { 'aria-label': 'Motivo de la eliminación', autocapitalize: 'off' },
      showCancelButton: true,
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#dc2626',
      cancelButtonColor: '#6b7280',
      reverseButtons: true,
      focusCancel: false,
      allowOutsideClick: () => !Swal.isLoading(),
      preConfirm: (motivo: string) => {
        const error = validarMotivo(motivo);
        if (error) {
          Swal.showValidationMessage(error);
          return false;
        }
        return motivo.trim();
      },
    });

    if (!result.isConfirmed) return;

    const client = {
      type_identity: this.person?.identitys[0]?.type_identity?.code,
      code_identity: this.person?.identitys[0]?.code_identity?.code,
      identity: this.person?.identitys[0]?.identity,
    };

    try {
      await this._user.clientQBuroReset(armarCuerpoEliminar(client, result.value));
      this.router.navigate([`/console/create-constacts`], {});
    } catch (error: any) {
      console.log(error);
      await Swal.fire({
        title: 'No se pudo eliminar',
        text: mensajeErrorEliminar(error),
        icon: 'error',
        confirmButtonText: 'Entendido',
      });
    }
  };

  getPerson = async () => {
    this.loading = true;

    try {
      const resp = await this._user.getPersonbyCode({
        code: this.queryParams.code,
      });

      this.getSection_transaction_by_person();

      this.person = resp.resp;
      this.cargarEstadoCt(this.person?.person?.code || this.queryParams.code);

      if(this.person?.resumen?.dias_morosidad > 0) {
        this.getFeeApply();
      }

      // 🆕 Buscar todas las domiciliaciones activas en una sola llamada optimizada
      const allDirectDebits = await this._user.getAllCustomerDirectDebitProcesses(
        this.person.identitys[0].code_identity.name,
        this.person.identitys[0].identity
      );
      
      console.log('📊 Todas las domiciliaciones activas:', allDirectDebits);
      console.log(`   Total procesos: ${allDirectDebits.total_processes}`);
      console.log(`   Por producto:`, allDirectDebits.by_product);
      
      // Iterar todos los procesos y agregar las facturas
      if (allDirectDebits.all_processes && allDirectDebits.all_processes.length > 0) {
        allDirectDebits.all_processes.forEach((process: any) => {
          if (process.invoice !== null) {
            this.direct_debit_customer.push(process.invoice);
          }
        });
      }
      
      console.log(`   ✅ Total facturas en domiciliación: ${this.direct_debit_customer.length}`);

      this.getAnalysis(this.person);

      this.invoicesPending();

      // Cargar fees de persona y calcular total pendiente (para banner)
      try {
        const customerId = this.person?.person?._id;
        if (customerId) {
          const pfResp = await this.feeService.getPersonFeesByCustomer(customerId, {});
          const list = pfResp?.data || [];
          const pending = list.filter((p: any) => p?.manual_deleted !== true && p?.payment_status?.code === 'PEN');
          this.pendingPersonDueTotal = pending.reduce((sum: number, p: any) => sum + (Number(p?.due_balance) || 0), 0);
          this.hasPendingPersonFees = this.pendingPersonDueTotal > 0;
        } else {
          this.hasPendingPersonFees = false;
          this.pendingPersonDueTotal = 0;
        }
      } catch (e) {
        console.log('Error cargando fees de persona para banner:', e);
        this.hasPendingPersonFees = false;
        this.pendingPersonDueTotal = 0;
      }
    } catch (error) {
      console.log(error);
    }

    this.loading = false;

    // Cargar estado de reactivación C004
    await this.loadReactivationStatus();
  };

  getIdentity(item: any) {
    if (!(item?.identitys?.length > 0)) return '';

    return `${item?.identitys[0]?.type_identity?.name} ${item?.identitys[0]?.code_identity?.name}-${item?.identitys[0]?.identity}`;
  }

  getContact(item: any) {
    if (!(item?.constacts?.length > 0)) return '';

    return `${item?.constacts[0]?.contact}`;
  }

  getEmailContact(item: any) {
    if (!(item?.constacts?.length > 0) || !item?.constacts[1]) return '';
    return `${item?.constacts[1]?.contact}`;
  }

  // Método para obtener solo el número de cédula (sin tipo ni nacionalidad)
  getIdentityNumber(item: any): string {
    if (!(item?.identitys?.length > 0)) return '';
    return item?.identitys[0]?.identity || '';
  }

  // Método para copiar número de teléfono al portapapeles
  async copyPhoneToClipboard(person: any): Promise<void> {
    try {
      const phoneNumber = this.getContact(person);
      if (phoneNumber) {
        // Remover el +58 si existe
        const cleanNumber = phoneNumber.replace(/^\+58/, '');
        
        // Copiar al portapapeles
        await navigator.clipboard.writeText(cleanNumber);
        
        // Mostrar notificación con alertifyjs
        alertifyjs.success(`Número copiado al portapapeles`);
      }
    } catch (error) {
      console.error('Error al copiar número:', error);
      // Fallback para navegadores que no soportan navigator.clipboard
      this.fallbackCopyToClipboard(person);
    }
  }

  // Método fallback para copiar teléfono en navegadores más antiguos
  fallbackCopyToClipboard(person: any): void {
    try {
      const phoneNumber = this.getContact(person);
      if (phoneNumber) {
        const cleanNumber = phoneNumber.replace(/^\+58/, '');
        
        // Crear elemento temporal
        const textArea = document.createElement('textarea');
        textArea.value = cleanNumber;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        
        // Mostrar notificación con alertifyjs
        alertifyjs.success(`Número copiado al portapapeles`);
      }
    } catch (error) {
      console.error('Error en fallback de copiado:', error);
    }
  }

  // Método para copiar número de cédula al portapapeles
  async copyIdentityToClipboard(person: any): Promise<void> {
    try {
      const identityNumber = this.getIdentityNumber(person);
      if (identityNumber) {
        // Copiar al portapapeles
        await navigator.clipboard.writeText(identityNumber);
        
        // Mostrar notificación con alertifyjs
        alertifyjs.success(`Cédula copiada al portapapeles`);
      }
    } catch (error) {
      console.error('Error al copiar cédula:', error);
      // Fallback para navegadores que no soportan navigator.clipboard
      this.fallbackCopyIdentityToClipboard(person);
    }
  }

  // Método fallback para copiar cédula en navegadores más antiguos
  fallbackCopyIdentityToClipboard(person: any): void {
    try {
      const identityNumber = this.getIdentityNumber(person);
      if (identityNumber) {
        // Crear elemento temporal
        const textArea = document.createElement('textarea');
        textArea.value = identityNumber;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        
        // Mostrar notificación con alertifyjs
        alertifyjs.success(`Cédula copiada al portapapeles`);
      }
    } catch (error) {
      console.error('Error en fallback de copiado cédula:', error);
    }
  }

  sanitize(url: string) {
    //return url;
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  public redirect = () => {
    let Doc_ID;
    let Type_ID;
    let TLF;

    if (this.person?.identitys?.length > 0) {
      const data = this.person?.identitys[0];
      Type_ID = data.type_identity?.additionalType;
      Doc_ID = data.identity;
    }

    const data = {
      CED: environment.CED,
      IP: environment.IP_LOCAL,
      Type_ID,
      Doc_ID,
      PN: this.person?.person?.name,
      PA: this.person?.person?.lastName,
      FN: this.datePipe.transform(
        this.person?.person?.birth_date,
        'yyyy-MM-dd'
      ),
      GN: this.person?.person?.gender,
      TLF: '',
      EMAIL: '',
    };

    this.redirecFormService.postRedirect(
      environment.externalPsicometrico,
      data
    );
  };

  pocisionBottom = async (content: TemplateRef<any>, data: any = {}) => {
    try {
      this.loadQuota = true;

      let result = await this.submit();
      this.offcanvasService.open(content, {
        position: 'end',
        keyboard: false,
        panelClass: 'custom-offcanvas-lg',
      });
    } catch (error) {
      console.log(error);
    }

    this.loadQuota = false;
  };

  // Abre el modal de detalle de crédito del cliente (Ajuste 06)
  // Usa el offcanvas-end con el mismo panelClass del resto del módulo.
  // Pre-fetch de la tasa Bs/$ para mostrar conversión consolidada.
  verDetalleCredito = (content: TemplateRef<any>) => {
    this.loadCreditRate();
    this.offcanvasService.open(content, {
      position: 'end',
      keyboard: true,
      panelClass: 'custom-offcanvas-lg'
    });
  };

  // Carga la tasa Bs/$ asociada al producto CRÉDITO
  loadCreditRate = async () => {
    try {
      this.loadingCreditRate = true;
      const response = await this.directDebitService.getProductRateInfo('CREDIT');
      if (response?.success && response.data?.rate_available) {
        this.creditRate = Number(response.data.rate) || null;
        this.creditRateAvailable = this.creditRate !== null && this.creditRate > 0;
      } else {
        this.creditRate = null;
        this.creditRateAvailable = false;
      }
    } catch (error) {
      console.error('Error al cargar tasa de crédito:', error);
      this.creditRate = null;
      this.creditRateAvailable = false;
    } finally {
      this.loadingCreditRate = false;
    }
  };

  // Total de la deuda en USD: cuotas vencidas + fees C001 pendientes.
  // NOTA: el fee de reactivación (C004) NO suma al total — es un cargo aparte
  // que no debe presentarse como deuda exigible al cliente.
  totalDeudaUsd = (): number => {
    const r = this.person?.resumen || {};
    return (Number(r.monto_adeudado_vencido) || 0)
      + (Number(r.fees_c001_pendientes_monto) || 0);
  };

  // Flag para ocultar la fila Penalidad por reactivación durante la captura PNG.
  hideC004ForCapture = false;

  // Convierte un monto USD a Bs usando la tasa cargada
  toBs = (usd: number | null | undefined): number | null => {
    if (!this.creditRateAvailable || this.creditRate == null) return null;
    const amount = Number(usd) || 0;
    return amount * this.creditRate;
  };

  // Descarga una captura PNG del resumen consolidado del modal Detalle de Crédito
  // Nota: el offcanvas se renderiza fuera del view del componente (vía portal), por eso
  // localizamos el contenedor por id en lugar de usar ViewChild.
  descargarDetalleCredito = async () => {
    if (this.downloadingCreditCapture) return;
    const node = document.getElementById('creditCaptureContainer') as HTMLElement | null;
    if (!node) {
      alertifyjs.error('No se pudo capturar el detalle. Intenta de nuevo.');
      return;
    }
    try {
      this.downloadingCreditCapture = true;
      // Ocultamos la fila de penalidad por reactivación (C004) en la captura:
      // ese cargo es interno y no debe figurar en el comprobante entregado al cliente.
      this.hideC004ForCapture = true;
      // Esperar un tick para que Angular re-renderice sin la fila C004.
      await new Promise(r => setTimeout(r, 0));
      const canvas = await html2canvas(node, {
        backgroundColor: '#ffffff',
        scale: 2,
        useCORS: true,
        logging: false
      });
      const dataUrl = canvas.toDataURL('image/png');
      const cedula = (this.getIdentity(this.person) || 'cliente').replace(/[^A-Za-z0-9\-]/g, '');
      const fecha = this.datePipe.transform(new Date(), 'yyyy-MM-dd_HH-mm') || 'fecha';
      const link = document.createElement('a');
      link.href = dataUrl;
      link.download = `detalle-credito_${cedula}_${fecha}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error al generar la captura del detalle de crédito:', error);
      alertifyjs.error('No se pudo generar la imagen del detalle.');
    } finally {
      this.hideC004ForCapture = false;
      this.downloadingCreditCapture = false;
    }
  };

  // ============================================
  // MÉTODOS: Historial de Cambios de Cupo
  // ============================================
  
  loadQuotaHistory = async () => {
    if (!this.person?.person?.code) return;
    
    try {
      this.loadingHistory = true;
      
      const params: any = {
        codePerson: this.person.person.code,
        page: this.historyPage,
        limit: this.historyLimit,
        isGlobal: false  // Consulta individual - NO incluir información de persona (ya se conoce)
      };

      // Agregar filtros de fecha si están completos
      if (this.dateRangeStart && this.dateRangeEnd) {
        params.fechaInicio = this.formatDateToMMDDYYYY(this.dateRangeStart);
        params.fechaFin = this.formatDateToMMDDYYYY(this.dateRangeEnd);
      }

      if (this.historyFilters.nombreEjecutivo) {
        params.nombreEjecutivo = this.historyFilters.nombreEjecutivo;
      }

      const response = await this._user.getQuotaHistory(params);
      
      if (response?.success) {
        this.quotaHistory = response.data;
        this.historyTotal = response.pagination.totalRecords;
        this.historyTotalPages = response.pagination.totalPages;
      }
    } catch (error) {
      console.error('Error al cargar historial de cupos:', error);
      alertifyjs.error('Error al cargar el historial de cupos');
    } finally {
      this.loadingHistory = false;
    }
  };

  toggleHistorySection = () => {
    this.showHistorySection = !this.showHistorySection;
    
    if (this.showHistorySection && this.quotaHistory.length === 0) {
      this.loadQuotaHistory();
    }
  };

  applyHistoryFilters = () => {
    this.historyPage = 1;
    this.loadQuotaHistory();
  };

  clearHistoryFilters = () => {
    this.historyFilters = {
      nombreEjecutivo: ''
    };
    this.dateRangeStart = null;
    this.dateRangeEnd = null;
    this.historyPage = 1;
    this.loadQuotaHistory();
  };

  changeHistoryPage = (page: number) => {
    if (page >= 1 && page <= this.historyTotalPages) {
      this.historyPage = page;
      this.loadQuotaHistory();
    }
  };

  getQuotaChangeClass = (quotaAntigua: number, quotaNueva: number): string => {
    if (quotaNueva > quotaAntigua) return 'text-green-600';
    if (quotaNueva < quotaAntigua) return 'text-red-600';
    return 'text-gray-600';
  };

  getQuotaChangeIcon = (quotaAntigua: number, quotaNueva: number): string => {
    if (quotaNueva > quotaAntigua) return 'fas fa-arrow-up';
    if (quotaNueva < quotaAntigua) return 'fas fa-arrow-down';
    return 'fas fa-minus';
  };

  // ============================================
  // PRODUCTOS COMPRADOS POR EL CLIENTE
  // ============================================

  toggleCustomerProducts = () => {
    this.showCustomerProducts = !this.showCustomerProducts;
    if (this.showCustomerProducts && this.customerProducts.length === 0) {
      this.loadCustomerProducts();
    }
  };

  // ============================================
  // DOMICILIACIONES BANCARIAS (sección colapsable)
  // Helpers de solo lectura para el resumen del header.
  // No modifican la lógica de afiliaciones; solo cuentan lo ya existente.
  // ============================================

  toggleDirectDebitSection = () => {
    this.showDirectDebitSection = !this.showDirectDebitSection;
  };

  get activeDirectDebitCount(): number {
    const products = this.person?.person?.product_direct_debit_afiliations;
    if (products && products.length > 0) {
      return products.filter((a: any) => a?.is_active).length;
    }
    return this.person?.person?.direct_debit_afiliation ? 1 : 0;
  }

  get hasActiveDirectDebit(): boolean {
    return this.activeDirectDebitCount > 0;
  }

  get deactivatedDirectDebitCount(): number {
    return this.person?.deactivation_history?.length || 0;
  }

  loadCustomerProducts = async () => {
    if (!this.person?.person?.code) return;
    this.loadingCustomerProducts = true;
    try {
      const resp = await this.catalogService.getProductsByCustomer(this.person.person.code);
      if (resp?.res) {
        this.customerProducts = resp.res.products || [];
        this.customerProductsSummary = resp.res.summary || null;
        this.customerProductsCurrency = resp.res.by_currency || [];
      }
    } catch (error) {
      console.error('Error cargando productos del cliente:', error);
    } finally {
      this.loadingCustomerProducts = false;
    }
  };

  formatCurrencyValue(value: number): string {
    if (!value && value !== 0) return '-';
    return value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  formatShortDate(dateStr: string): string {
    if (!dateStr) return '-';
    const d = new Date(dateStr);
    return d.toLocaleDateString('es-VE', { day: '2-digit', month: '2-digit', year: 'numeric' });
  }

  // ============================================
  // UTILIDADES DE FECHA
  // ============================================
  formatDateToMMDDYYYY(date: Date): string {
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  }

  // modal = async (contentPlans: TemplateRef<any>, data: any = {}) => {
  //   try {
  //     this.loadPlans = true;

  //     let result = await this.submit();
  //     this.offcanvasService.open(contentPlans, {
  //       position: 'bottom',
  //       keyboard: false,
  //     });
  //   } catch (error) {
  //     console.log(error);
  //   }

  //   this.loadPlans = false;
  // };

  // Cargar estado de validación de fee C004
  async loadReactivationStatus() {
    if (!this.person?.person?.code) return;
    
    try {
      this.loadingReactivationStatus = true;
      const response = await lastValueFrom(
        this._user.validateReactivationStatus(this.person.person.code)
      );
      
      if (response.success) {
        this.reactivationStatus = response.data;
      }
    } catch (error) {
      console.error('Error cargando estado de reactivación:', error);
      this.reactivationStatus = null;
    } finally {
      this.loadingReactivationStatus = false;
    }
  }

  submit = async () => {
    let person = this.person;

    return new Promise(async (resolve, reject) => {
      this.identityResponse = `${person?.identitys[0]?.code_identity?.name}-${person?.identitys[0]?.identity}`;

      let params = { code_person: person?.person?.code };

      try {
        let resp = await this._user.clientCountCreditPending(params);

        this.searchPerson = resp?.res?.person;

        this.usQuote = this.searchPerson?.quota_active;
        this.usQuoteClien = this.searchPerson?.quota_client_active;

        this.countInvoice = resp?.res?.countInvoice;

        // Get complete person data with file_selfie.url for the modal
        if (this.searchPerson?.code) {
          try {
            const personResp = await this._user.getPersonbyCode({
              code: this.searchPerson.code,
            });

            // Merge the complete file_selfie data into searchPerson
            if (personResp?.resp?.person?.file_selfie) {
              this.searchPerson.file_selfie = personResp.resp.person.file_selfie;
            }
            
            // Merge penalty reactivation data
            if (personResp?.resp?.person?.penalty_reactivation_count !== undefined) {
              this.searchPerson.penalty_reactivation_count = personResp.resp.person.penalty_reactivation_count;
            }
            if (personResp?.resp?.person?.penalty_reactivation_history) {
              this.searchPerson.penalty_reactivation_history = personResp.resp.person.penalty_reactivation_history;
            }
          } catch (error) {
            console.log('Error getting complete person data:', error);
          }
        }

        resolve(true);
      } catch (error: any) {
        console.log(error);

        reject(error);
      }
    });
  };

  offcanvasServiceClose() {
    this.offcanvasService.dismiss();
  }

  activeCupo = async (code: any) => {
    let params = {
      code_person: code,
      id_ejecutive: this._auth.sessionUser?.uid,
    };

    try {
      let resp = await this._user.activeCupo(params);
      this.getPerson();
    } catch (error: any) {
      console.log(error);
    }
  };

  manual_approve = async (code: any) => {
    Swal.fire({
      title: 'Alerta',
      text: '¿Estas seguro que deseas aprobar manualmente?',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      showCancelButton: true,
      confirmButtonText: `Si!`,
      cancelButtonText: `Cancelar!`,
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      if (result.isConfirmed) {
        let params = {
          codePerson: code,
        };

        try {
          let resp = await this._user.manual_approve(params);
          alertifyjs.success(`Aprobación exitosa`);

          this.getPerson();
        } catch (error: any) {
          console.log(error);
        }
      }
    });
  };

  toogleStatus = async (st = this.usQuote) => {
    let status = st ? true : false;

    let action = status ? 'Habilitar' : 'Inhabilitar';

    if(status) {
      Swal.fire({
        title: `¿Porqué desea ${action} este cupo?`,
        text: "¡No podrás revertir esto!",
        confirmButtonColor: '#3085D6',
        cancelButtonColor: '#d33',
        input: "textarea",
        inputAttributes: {
          autocapitalize: "off"
        },
        showCancelButton: true,
        confirmButtonText: `Si, ${action}!`,
        showLoaderOnConfirm: true,
        preConfirm: async (data) => {
          try {
            if (data?.trim() == '') {
              return Swal.showValidationMessage(`Debe añadir una comentario`);
            }

            this.userComment = data;

          } catch (error) {
            Swal.showValidationMessage(`
              Request failed: ${error}
            `);
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
        cancelButtonText: `Cancelar`
      }).then(async (data) => {
        if (data.isConfirmed) {
          try {
            let query = {
              code_person: this.searchPerson?.code,
              status,
              description: data.value
            };

            await this._user.status_quote_user(query);
            alertifyjs.success('Cambio de estatus exitoso');

            this.getPerson();
          } catch (error) {
            this.usQuote = !this.usQuote;
            alertifyjs.error('Error al cambiar estatus');
        }
        }else if (data.isDismissed) {
          this.usQuote = !this.usQuote;
        }
      });
    } else {
      Swal.fire({
        title: `¿Porqué desea ${action} este cupo?`,
        text: "¡No podrás revertir esto!",
        confirmButtonColor: '#3085D6',
        cancelButtonColor: '#d33',
        input: 'select',
        inputOptions: {
          1: 'Morosidad (Permite activarse al cancelar la deuda si aplica)',
          2: 'Fallecimiento',
          3: 'Fraude',
          4: 'Falsificación de documentos',
          5: 'Perdida incobrable',
          6: 'Solicitado por el cliente',
          7: 'Ex-empleado',
          8: 'Incumplimiento de pago'
        },
        inputPlaceholder: 'Selecciona un motivo',
        inputAttributes: {
          autocapitalize: "off"
        },
        showCancelButton: true,
        confirmButtonText: `Si, ${action}!`,
        showLoaderOnConfirm: true,
        preConfirm: async (data) => {
          try {
            if (data?.trim() == '') {
              return Swal.showValidationMessage(`Debe añadir una comentario`);
            }

            this.userComment = data;

          } catch (error) {
            Swal.showValidationMessage(`
              Request failed: ${error}
            `);
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
        cancelButtonText: `Cancelar`
      }).then(async (data) => {
        if (data.isConfirmed) {
          try {
            let query = {
              code_person: this.searchPerson?.code,
              status,
              option: data.value
            };

            await this._user.status_quote_user(query);
            alertifyjs.success('Cambio de estatus exitoso');

            this.getPerson();
          } catch (error) {
            this.usQuote = !this.usQuote;
            alertifyjs.error('Error al cambiar estatus');
        }
        }else if (data.isDismissed) {
          this.usQuote = !this.usQuote;
        }
      });
    }

  };

  toogleStatusClient = async (st = this.usQuoteClien) => {
    let status = st ? true : false;

    try {
      let query = {
        status,
        code_person: this.person?.person?.code,
      };

      const resp = await this._user.toogleStatusClient(query);

      this.getPerson();
    } catch (error) {
      this.usQuoteClien = !status;
      console.log(error);
    }
  };

  invoicesPending = async () => {
    try {
      let params = { code_person: this.person?.person?.code };

      let resp = await this._user.clientCountCreditPending(params);

      this.searchPerson = resp?.res?.person;

      this.usQuote = this.searchPerson?.quota_active;
      this.usQuoteClien = this.searchPerson?.quota_client_active;

      this.countInvoice = resp?.res?.countInvoice;

      // Get complete person data with file_selfie.url for the modal
      if (this.searchPerson?.code) {
        try {
          const personResp = await this._user.getPersonbyCode({
            code: this.searchPerson.code,
          });

          // Merge the complete file_selfie data into searchPerson
          if (personResp?.resp?.person?.file_selfie) {
            this.searchPerson.file_selfie = personResp.resp.person.file_selfie;
          }
          
          // Merge penalty reactivation data
          if (personResp?.resp?.person?.penalty_reactivation_count !== undefined) {
            this.searchPerson.penalty_reactivation_count = personResp.resp.person.penalty_reactivation_count;
          }
          if (personResp?.resp?.person?.penalty_reactivation_history) {
            this.searchPerson.penalty_reactivation_history = personResp.resp.person.penalty_reactivation_history;
          }
        } catch (error) {
          console.log('Error getting complete person data:', error);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  getAnalysis = async (item: any, reload = true) => {
    try {
      let params = {
        codePerson: item?.person?.code,
      };

      const analysis = await this._user.getAnalysis(params);

      let analysis_response =
        Object.keys(analysis?.result).length > 0 &&
        analysis?.result?.constructor === Object
          ? analysis?.result
          : null;

    this.analysis_response = analysis_response;
      this.status_approved = analysis_response.approve_status;
    } catch (error) {
      console.log(error);
    }
  };

  change_quote = async () => {
    this.submit_disabled_quote = true;
    try {
      let params = {
        increment_type: 'S',
        amount: this.new_quote,
        code_person: this.person?.person?.code,
      };
      this.loading_ap = false;

      const analysis = await this._user.update_quote_person(params);
      alertifyjs.success(`Cambio exitoso`);

      this.submit_disabled_quote = false;
      this.edit_quote = false;
      this.new_quote = '';

      this.getPerson();
    } catch (error: any) {
      console.log(error);
      this.loading_ap = false;
      alertifyjs.error(error?.error?.msg);
      this.new_quote = '';
      this.submit_disabled_quote = false;
    }
  };

  // TODO: Mario, revisar esto porque tuvo conflictos en el Merge
  // Mario: si hay morosidad, debo buscar que regla se puede aplicar para cobrar la Penalidad
  getFeeApply = async() => {
    try {
      this.fee_to_apply = await this.feeService.findFeeToApply(this.fee_later_payment_code, 'LATE_PAYMENT_DAYS', this.person?.resumen?.dias_morosidad);
    } catch (error) {
      this.fee_to_apply = null;
      console.log(error);
    }
  }

  openBottom= async (content: TemplateRef<any>,params_invoice:any) => {
    try {
      console.log(params_invoice);

      this.params_payment = params_invoice;

      this.offcanvasService.open(content, {
        position: 'bottom',
        keyboard: false,

      });


    } catch (error) {
      console.log(error);
    }
  };

  response = (event: any) => {}

  // 🆕 MULTI-PRODUCTO: Cargar productos activos del sistema
  async loadActiveProducts() {
    try {
      const response: any = await this._user.getAllCodesProduct();
      if (response?.success && response?.codes_product) {
        this.activeProducts = response.codes_product.filter((p: any) => p.status === 'ACTIVE');
        console.log('📦 [contact-profile] Productos activos cargados:', this.activeProducts);
      }
    } catch (error) {
      console.error('❌ [contact-profile] Error cargando productos:', error);
      // Fallback a productos por defecto si falla la carga
      this.activeProducts = [
        { code: 'CREDIT', name: 'Crédito' },
        { code: 'SEGUROS_MERCANTIL', name: 'Seguros Mercantil' },
        { code: 'RECARGAS', name: 'Recargas' }
      ];
    }
  }

  /** Estado de las cuentas frente a CrediTotal (etiquetas). Sin esperar y sin romper nada si falla. */
  cuentasCt: any[] = [];
  cargarEstadoCt(code: any): void {
    this.domiciliacionCt.getCuentasCliente(code).then(c => (this.cuentasCt = c)).catch(() => (this.cuentasCt = []));
  }

  cuentaCt(bank: any, product: string): any {
    return this.domiciliacionCt.buscarCuenta(this.cuentasCt, { bank, product });
  }

  // 🆕 MULTI-PRODUCTO: Mapeo de códigos de producto a nombres (dinámico)
  getProductName(productCode: string): string {
    const product = this.activeProducts.find(p => p.code === productCode);
    return product ? product.name : productCode;
  }

  // Mora reiniciada/recontada DESPUÉS de la reactivación (mora.effective): solo cuenta
  // las cuotas vencidas posteriores a la última reactivación. Es la que usa la lógica de
  // reactivación como validación (resolveEffectiveMora / validateReactivation).
  getReactivationEffectiveMora(personObj: any): number | null {
    // Solo aplica si el cliente realmente PAGÓ una reactivación por penalidad
    // (mismo criterio que el badge "Reactivado por penalidad").
    if (!(personObj?.penalty_reactivation_count > 0)) return null;
    const eff = personObj?.mora?.effective;
    return (typeof eff === 'number') ? eff : null;
  }

}
